export const public_path = '/'
export const coingeckoAPIURl = 'https://api.coingecko.com/api/v3'
export const Discord_BOT_URL = 'https://discord-bot.derex.exchange'
export const MULTI_SWAP_URL = 'https://multiswap.derex.exchange'
export const BOND_SERVER_URL = process.env.REACT_APP_BOND_SERVER
export const LARGE_APPROVAL_AMOUNT = 999
